import React from 'react'

import SolidHeartIcon from 'components/Luxkit/Icons/solid/SolidHeartIcon'
import IconInCircle from 'tripPlanner/components/Icons/IconInCircle'

interface Props {
  size?: number
  iconSize?: number
}

function PinHeart({ size = 8, iconSize = 14 }: Props) {
  return (
    <IconInCircle
      icon={SolidHeartIcon}
      iconColour="neutral-eight"
      iconSize={size}
      size={iconSize}
      circleColour="favourite"
    />
  )
}

export default PinHeart
